module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_vm._v("广告管理")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex-row-between margin-20"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.openCampus(null)
      }
    }
  }, [_vm._v("学校个性化")]), _vm._v(" "), _c('div', [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEdit),
      expression: "!isEdit"
    }],
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.isEdit = !_vm.isEdit
      }
    }
  }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit),
      expression: "isEdit"
    }],
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit),
      expression: "isEdit"
    }],
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, _vm._l((_vm.tableHeader), function(item) {
    return _c('el-table-column', {
      key: item.value,
      attrs: {
        "label": item.label,
        "align": "center"
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return [(_vm.$index === 0) ? _c('div', {
              staticClass: "hotLoad"
            }, [_c('span', [_vm._v("热启动间隔")]), _vm._v(" "), _c('span', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (!_vm.isEdit),
                expression: "!isEdit"
              }]
            }, [_vm._v(_vm._s(_vm.row[item.value] || 0))]), _vm._v(" "), _c('el-input-number', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (_vm.isEdit),
                expression: "isEdit"
              }],
              attrs: {
                "min": 0,
                "size": "small"
              },
              model: {
                value: (_vm.row[item.value]),
                callback: function($$v) {
                  _vm.$set(_vm.row, item.value, $$v)
                },
                expression: "row[item.value]"
              }
            }), _vm._v("秒\n               ")], 1) : _vm._e(), _vm._v(" "), (_vm.$index === 1) ? _c('div', [_vm._v("冷启动间隔" + _vm._s(_vm.row[item.value] || 0) + "秒")]) : _vm._e()]
          
        },
        staticRenderFns: []
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "diy-list"
  }, _vm._l((_vm.hotSpots), function(item) {
    return _c('div', {
      key: item.key,
      staticClass: "diy-item"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('span', [_vm._v("\n                  【热启动】开屏" + _vm._s(item.openScreenAd) + "秒；首页弹窗" + _vm._s(item.homeScreenAd) + "秒；我的" + _vm._s(item.myInformationFlowAd) + "秒\n               ")]), _vm._v(" "), _c('div', {
      staticClass: "op-list"
    }, [_c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.openCampus(item)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.caDel(item)
        }
      }
    }, [_vm._v("删除")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "card-wrap"
    }, [_c('el-row', {
      attrs: {
        "gutter": 16
      }
    }, _vm._l((item.models), function(mo) {
      return _c('el-col', {
        key: mo.unid,
        staticClass: "card-item",
        attrs: {
          "span": 6
        }
      }, [_vm._v("\n                     " + _vm._s(mo.name) + "\n                  ")])
    }), 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "card-footer"
    }, [_vm._v("共计" + _vm._s(item.models.length) + "所学校")])])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "search-wrapper"
  }, [_c('h2', [_vm._v("倍孜广告开关")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": _vm.bindSwitchChange
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.value) ? _c('div', {
    staticClass: "check-date"
  }, [_c('div', [_vm._v("每周策略")]), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.dateChecked),
      callback: function($$v) {
        _vm.dateChecked = $$v
      },
      expression: "dateChecked"
    }
  }, _vm._l((_vm.dateOptions), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      attrs: {
        "label": item.value,
        "disabled": !_vm.dateEditing
      }
    }, [_vm._v("\n               " + _vm._s(item.label) + "\n            ")])
  }), 1), _vm._v(" "), (!_vm.dateEditing) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.clickDateCheck(1)
      }
    }
  }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (_vm.dateEditing) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.clickDateCheck(2)
      }
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), (_vm.dateEditing) ? _c('el-button', {
    staticStyle: {
      "color": "#666"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.clickDateCheck(3)
      }
    }
  }, [_vm._v("取消")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "search-wrapper"
  }, [_c('h2', [_vm._v("广告屏蔽校区")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": _vm.changeSchoolAreaAdShield
    },
    model: {
      value: (_vm.schoolAreaAdShield),
      callback: function($$v) {
        _vm.schoolAreaAdShield = $$v
      },
      expression: "schoolAreaAdShield"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper margin-top-10 margin-bottom-20"
  }, [_c('div', {
    staticClass: "diy-list"
  }, [_c('div', {
    staticClass: "diy-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("插屏（首页）")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.handleEditCampus('homeAd')
      }
    }
  }, [_vm._v("编辑")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-wrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, _vm._l((_vm.homeAd), function(item) {
    return _c('el-col', {
      key: item.value,
      staticClass: "card-item",
      attrs: {
        "span": 6
      }
    }, [_vm._v("\n                     " + _vm._s(item.label) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("共计" + _vm._s(_vm.homeAd.length) + "所学校")])]), _vm._v(" "), _c('div', {
    staticClass: "diy-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("开屏")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.handleEditCampus('openAd')
      }
    }
  }, [_vm._v("编辑")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-wrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, _vm._l((_vm.openAd), function(item) {
    return _c('el-col', {
      key: item.value,
      staticClass: "card-item",
      attrs: {
        "span": 6
      }
    }, [_vm._v("\n                     " + _vm._s(item.label) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("共计" + _vm._s(_vm.openAd.length) + "所学校")])]), _vm._v(" "), _c('div', {
    staticClass: "diy-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("插屏（跑步结束页）")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.handleEditCampus('runAd')
      }
    }
  }, [_vm._v("编辑")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-wrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, _vm._l((_vm.runAd), function(item) {
    return _c('el-col', {
      key: item.value,
      staticClass: "card-item",
      attrs: {
        "span": 6
      }
    }, [_vm._v("\n                     " + _vm._s(item.label) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("共计" + _vm._s(_vm.runAd.length) + "所学校")])]), _vm._v(" "), _c('div', {
    staticClass: "diy-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("信息流（我的）")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.handleEditCampus('flowAd')
      }
    }
  }, [_vm._v("编辑")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-wrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, _vm._l((_vm.flowAd), function(item) {
    return _c('el-col', {
      key: item.value,
      staticClass: "card-item",
      attrs: {
        "span": 6
      }
    }, [_vm._v("\n                     " + _vm._s(item.label) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("共计" + _vm._s(_vm.flowAd.length) + "所学校")])]), _vm._v(" "), _c('div', {
    staticClass: "diy-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("无障碍校区屏蔽")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.handleEditCampus('barrierFree')
      }
    }
  }, [_vm._v("编辑")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-wrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, _vm._l((_vm.barrierFree), function(item) {
    return _c('el-col', {
      key: item.value,
      staticClass: "card-item",
      attrs: {
        "span": 6
      }
    }, [_vm._v("\n                     " + _vm._s(item.label) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("共计" + _vm._s(_vm.barrierFree.length) + "所学校")])]), _vm._v(" "), _c('div', {
    staticClass: "diy-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("信息流（首页）")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.handleEditCampus('homeFlowAd')
      }
    }
  }, [_vm._v("编辑")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-wrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, _vm._l((_vm.homeFlowAd), function(item) {
    return _c('el-col', {
      key: item.value,
      staticClass: "card-item",
      attrs: {
        "span": 6
      }
    }, [_vm._v("\n                     " + _vm._s(item.label) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("共计" + _vm._s(_vm.homeFlowAd.length) + "所学校")])]), _vm._v(" "), _c('div', {
    staticClass: "diy-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("信息流（跑步结束页）")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.handleEditCampus('runFlowAd')
      }
    }
  }, [_vm._v("编辑")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-wrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, _vm._l((_vm.runFlowAd), function(item) {
    return _c('el-col', {
      key: item.value,
      staticClass: "card-item",
      attrs: {
        "span": 6
      }
    }, [_vm._v("\n                     " + _vm._s(item.label) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("共计" + _vm._s(_vm.runFlowAd.length) + "所学校")])]), _vm._v(" "), _c('div', {
    staticClass: "diy-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("悬浮窗广告屏蔽")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.handleEditCampus('floatingAd')
      }
    }
  }, [_vm._v("编辑")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-wrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, _vm._l((_vm.floatingAd), function(item) {
    return _c('el-col', {
      key: item.value,
      staticClass: "card-item",
      attrs: {
        "span": 6
      }
    }, [_vm._v("\n                     " + _vm._s(item.label) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("共计" + _vm._s(_vm.floatingAd.length) + "所学校")])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "flex-row gap-20 margin-top-20 margin-left-20"
  }, [_c('el-button', [_c('a', {
    attrs: {
      "href": "https://admin.gxapp.iydsj.com/template/ad_config.xlsx"
    }
  }, [_vm._v("模板下载")])]), _vm._v(" "), _c('el-upload', {
    attrs: {
      "with-credentials": true,
      "name": "uploadFile",
      "action": _vm.configActionUrl,
      "before-upload": _vm.beforeConfigUpload,
      "on-success": _vm.handleConfigSuccess,
      "on-error": _vm.handleConfigError
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("导入")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper margin-bottom-20"
  }, [_c('div', {
    staticClass: "diy-list"
  }, [_c('div', {
    staticClass: "diy-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("倍孜")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.handleEditCampus('beiziConfigs')
      }
    }
  }, [_vm._v("编辑")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-wrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, _vm._l((_vm.beiziConfigs), function(item) {
    return _c('el-col', {
      key: item.value,
      staticClass: "card-item",
      attrs: {
        "span": 6
      }
    }, [_vm._v("\n                     " + _vm._s(item.label) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("共计" + _vm._s(_vm.beiziConfigs.length) + "所学校")])]), _vm._v(" "), _c('div', {
    staticClass: "diy-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("美数")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.handleEditCampus('meishuConfigs')
      }
    }
  }, [_vm._v("编辑")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-wrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, _vm._l((_vm.meishuConfigs), function(item) {
    return _c('el-col', {
      key: item.value,
      staticClass: "card-item",
      attrs: {
        "span": 6
      }
    }, [_vm._v("\n                     " + _vm._s(item.label) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("共计" + _vm._s(_vm.meishuConfigs.length) + "所学校")])])])]), _vm._v(" "), _c('DiyCampusDialog', {
    ref: "DiyCampusRef",
    attrs: {
      "CampusZoneList": _vm.CampusZoneList
    },
    on: {
      "getData": _vm.getHotSpots
    }
  }), _vm._v(" "), _c('EditCampusDialog', {
    ref: "editCampusRef",
    attrs: {
      "campusZoneList": _vm.CampusZoneList
    },
    on: {
      "refreshCampusData": _vm.refreshCampusData
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-wrapper"
  }, [_c('h2', [_vm._v("广告间隔管理")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-wrapper"
  }, [_c('h2', [_vm._v("安卓-广告分配管理")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c07301c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/AdvertisingSpace/AdManagement/AdManagement.vue
// module id = 1120
// module chunks = 0